var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#5F9717",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17725 0 0 7.17725 0 16C0 24.8228 7.17725 32 16 32C24.8228 32 32 24.8228 32 16C32 7.17725 24.8228 0 16 0ZM23 17.3333H17.3333V23C17.3333 23.7361 16.7361 24.3333 16 24.3333C15.2639 24.3333 14.6667 23.7361 14.6667 23V17.3333H9C8.26392 17.3333 7.66675 16.7361 7.66675 16C7.66675 15.2639 8.26392 14.6667 9 14.6667H14.6667V9C14.6667 8.26392 15.2639 7.66675 16 7.66675C16.7361 7.66675 17.3333 8.26392 17.3333 9V14.6667H23C23.7361 14.6667 24.3333 15.2639 24.3333 16C24.3333 16.7361 23.7361 17.3333 23 17.3333Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRound);
export default ForwardRef;